<div>
    <div class="row mt-2">
        <div class="col-md-3">
            <label class="form-label">Category</label>
            <div class="form-group">
                <select class="form-select shadow-none" [(ngModel)]="strategyParams.category" disabled="true">
                    <option *ngFor="let category of categories" [value]="category.name"> {{ category.name }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-3">
            <label class="form-label">Segment</label>
            <div class="form-group">
                <select class="form-select shadow-none" [(ngModel)]="strategyParams.segment" disabled="true">
                    <option *ngFor="let s of segments" [value]="s.name"> {{ s.name }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-label"> Symbol</label>
            <div class="form-group">
                <select class="form-select shadow-none" [(ngModel)]="strategyParams.trading_symbol" (change)="onSymbolSelected(strategyParams)">
                    <option *ngFor="let sym of symbols" [disabled]="sym.disabled" [value]="sym.name"> {{ sym.name }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-6">
            <label class="form-label">Entry Time</label>
            <div class="form-group">
                <input id="entry_time" type="time" class="form-control timer-size shadow-none" autocomplete="off" [(ngModel)]="strategyParams.entry_time" >
                <!-- <label for="entry_time">Entry Time</label> -->
            </div>
            <div class="invalid-feedback" [ngClass]="timeValueClass(strategyParams)">
                Entry time should be lesser than Exit time
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-label">Exit Time</label>
            <div class="form-group">
                <input type="time" class="form-control timer-size shadow-none" autocomplete="off" [(ngModel)]="strategyParams.exit_time" >
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-6">
            <label class="form-label">Lots</label>
            <div class="form-group">
                <input type="number" class="form-control shadow-none" step="1" min="1" (keypress)="numberOnly($event)" [(ngModel)]="strategyParams.lots.value" required >
                <div class="invalid-feedback" [ngClass]="lotClass(strategyParams)">
                    Please provide atleast 1 Lot.
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-label">Interval</label>
            <div class="form-group">
                <div class="form-group">
                    <select class="form-select shadow-none" [(ngModel)]="strategyParams.selectedIntervalId" (change)="onIntervalChanged(strategyParams)">
                        <option *ngFor="let i of intervals" [value]="i._id"> {{ i.name }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-12">
            <label class="form-label">Strike Selection</label>
            <div class="input-group mb-3">
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {{ strategyParams.ss.name }}
                </button>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" [ngClass]="ssClass(strategyParams, 'default')" (click)="onSSSelect(strategyParams, 'default')">ATM</a></li>
                  <li><a class="dropdown-item" [ngClass]="ssClass(strategyParams, 'premium')" (click)="onSSSelect(strategyParams, 'premium')">Premium</a></li>
                </ul>
                <input type="number" class="form-control shadow-none" [(ngModel)]="strategyParams.ss.value.ce" (keypress)="numberOnly($event)"
                [step]="strategyParams.ss.step.ce" [min]="strategyParams.ss.min.ce" [max]="strategyParams.ss.max.ce"
                aria-label="number input for CE strike selection" >
                <input type="number" class="form-control shadow-none" [(ngModel)]="strategyParams.ss.value.pe" (keypress)="numberOnly($event)"
                [step]="strategyParams.ss.step.pe" [min]="strategyParams.ss.min.pe" [max]="strategyParams.ss.max.pe"
                aria-label="number input for PE strike selection" >
                <div class="invalid-feedback" [ngClass]="ssValueClass(strategyParams, 'ce')">
                    Please provide {{ strategyParams.ss.val_err_text.ce }}.
                </div>
                <div class="invalid-feedback" [ngClass]="ssValueClass(strategyParams, 'pe')">
                    Please provide {{ strategyParams.ss.val_err_text.pe }}.
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label class="form-label">Reenter</label>
            <div class="input-group">
                <div class="input-group-text p-1">
                    <input class="form-check-input mt-0 shadow-none" type="checkbox"
                    [checked]="strategyParams.reenter.state == 'enabled'"
                    (change)="onReenterStateChanged(strategyParams, $event)" aria-label="Checkbox for Reenter"
                    >
                </div>
                <!-- <span class="input-group-text p-1">Reenter</span> -->
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none"
                [disabled]="strategyParams.reenter.state == 'disabled'" type="button" data-bs-toggle="dropdown" 
                aria-expanded="false">
                    {{ strategyParams.reenter.on_text }}
                </button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" [ngClass]="reenterClass(strategyParams, 'both')" (click)="onReenterSelect(strategyParams, 'both')">Both</a></li>
                    <li><a class="dropdown-item" [ngClass]="reenterClass(strategyParams, 'sl')" (click)="onReenterSelect(strategyParams, 'sl')">SL</a></li>
                    <li><a class="dropdown-item" [ngClass]="reenterClass(strategyParams, 'tgt')" (click)="onReenterSelect(strategyParams, 'tgt')">Target</a></li>
                </ul>
                <input type="number" min="-1" step="1" max="100" class="form-control shadow-none"
                [(ngModel)]="strategyParams.reenter.count" aria-label="Text input for reenter"
                [disabled]="strategyParams.reenter.state == 'disabled'"
                >
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-label">Exit On</label>
            <div class="input-group">
                <div class="input-group-text p-1">
                    <input class="form-check-input mt-0 shadow-none" type="checkbox"
                    [disabled]="canDisable(strategyParams)"
                    [checked]="strategyParams.exit_on.state == 'enabled'"
                    (change)="onExitOnStateChanged(strategyParams, $event)" aria-label="Checkbox for Exit On"
                    >
                </div>
                <!-- <span class="input-group-text p-1">Reenter</span> -->
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none"
                [disabled]="strategyParams.exit_on.state == 'disabled'" type="button" data-bs-toggle="dropdown" 
                aria-expanded="false">
                    {{ strategyParams.exit_on.type_text }}
                </button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" *ngIf="showExitOnOption(strategyParams, 'both')" [ngClass]="exitOnClass(strategyParams, 'both')" (click)="onExitOnSelect(strategyParams, 'both')">Both</a></li>
                    <li><a class="dropdown-item" *ngIf="showExitOnOption(strategyParams, 'sl')" [ngClass]="exitOnClass(strategyParams, 'sl')" (click)="onExitOnSelect(strategyParams, 'sl')">SL</a></li>
                    <li><a class="dropdown-item" *ngIf="showExitOnOption(strategyParams, 'tgt')" [ngClass]="exitOnClass(strategyParams, 'tgt')" (click)="onExitOnSelect(strategyParams, 'tgt')">Target</a></li>
                </ul>
            </div>
            <div class="invalid-feedback" [ngClass]="exitOnValueClass(strategyParams)">
                Please select Exit On or disabled it.
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-12 d-flex align-items-end justify-content-evenly">
            <div class="btn-group btn-group-sm" role="group">
                <input type="radio" class="btn-check" name="btnradio" id="btnBuy" autocomplete="off"
                [checked]="strategyParams.tt == 'buy'" (click)="onTTSelect(strategyParams, 'buy')"
                >
                <label class="btn shadow-none" for="btnBuy" [ngClass]="ttClass(strategyParams, 'buy')">Buy</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnSell" autocomplete="off"
                [checked]="strategyParams.tt == 'sell'" (click)="onTTSelect(strategyParams, 'sell')"
                >
                <label class="btn shadow-none" for="btnSell" [ngClass]="ttClass(strategyParams, 'sell')">Sell</label>
            </div>
            <div class="btn-group btn-group-sm" role="group">
                <input type="radio" class="btn-check" name="btnradio" id="btnDryrun" autocomplete="off"
                [checked]="strategyParams.run_mode == 'dry_run'" (click)="onModeSelect(strategyParams, 'dry_run')"
                >
                <label class="btn shadow-none" for="btnDryrun" [ngClass]="modeClass(strategyParams, 'dry_run')">Dryrun</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnLive" autocomplete="off"
                [checked]="strategyParams.run_mode == 'live'" (click)="onModeSelect(strategyParams, 'live')"
                >
                <label class="btn shadow-none" for="btnLive" [ngClass]="modeClass(strategyParams, 'live')">Live</label>
            </div>
            <div class="btn-group btn-group-sm" role="group">
                <input type="radio" class="btn-check" name="btnradio" id="btnMis" autocomplete="off"
                [checked]="strategyParams.pt == 'mis'" (click)="onPTSelect(strategyParams, 'mis')"
                >
                <label class="btn shadow-none" for="btnMis" [ngClass]="ptClass(strategyParams, 'mis')">MIS</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnNrml" autocomplete="off"
                [checked]="strategyParams.pt == 'nrml'" (click)="onPTSelect(strategyParams, 'nrml')"
                >
                <label class="btn shadow-none" for="btnNrml" [ngClass]="ptClass(strategyParams, 'nrml')">NRML</label>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="input-group mb-3">
            <div class="input-group-text bg-transparent">
                <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                [checked]="strategyParams.tgt.state == 'enabled' || strategyParams.combined_tgt.state == 'enabled'"
                (change)="onSLTgtCheckChange(strategyParams, $event, 'tgt')"
                aria-label="Checkbox for following text input"
                >
            </div>
            <a class="btn bg-transparent border border-start-0 flex-fill"
            [attr.data-bs-toggle]="strategyParams.tgt.content || strategyParams.combined_tgt.content" data-bs-target="#collapseTgt" type="button"
            [ngClass]="slTgtClass(strategyParams, 'tgt')" (click)="onSLTgtPanelClick(strategyParams, 'tgt')"
            aria-expanded="false" aria-controls="collapseTgt">Target</a>
            <span class="input-group-text bg-transparent border border-start-0"
            [attr.data-bs-toggle]="strategyParams.tgt.content || strategyParams.combined_tgt.content" data-bs-target="#collapseTgt"
            (click)="onSLTgtPanelClick(strategyParams, 'tgt')">
                <i class="bi bi-chevron-down" [ngClass]="slTgtClass(strategyParams, 'tgt')"></i>
            </span>
        </div>
    </div>
    <div class="collapse row mt-2" id="collapseTgt">
        <div class="col">
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.tgt.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'tgt')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">Leg</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'tgt')">
                        {{ strategyParams.tgt.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'tgt')" (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'tgt')">Points</a></li>
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'tgt')" (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'tgt')">Percent</a></li>
                    </ul>
                </div>
                <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.tgt.value"
                step="0.1" min="1" aria-label="number input for target value"
                [ngClass]="slTgtErrValueClass(strategyParams, 'tgt')">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.combined_tgt.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'combined_tgt')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">Strategy</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'combined_tgt')">
                        {{ strategyParams.combined_tgt.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'combined_tgt')" (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'combined_tgt')">Points</a></li>
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'combined_tgt')" (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'combined_tgt')">Percent</a></li>
                    </ul>
                </div>
                <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.combined_tgt.value"
                step="0.1" min="1" aria-label="number input for target value"
                [ngClass]="slTgtErrValueClass(strategyParams, 'combined_tgt')">
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="input-group mb-3">
            <div class="input-group-text bg-transparent">
                <input class="form-check-input mt-0 shadow-none" type="checkbox"
                [checked]="strategyParams.sl.state == 'enabled' || strategyParams.combined_sl.state == 'enabled'"
                (change)="onSLTgtCheckChange(strategyParams, $event, 'sl')"
                aria-label="Checkbox for following text input" >
            </div>
            <a class="btn bg-transparent border border-start-0 flex-fill"
            [attr.data-bs-toggle]="strategyParams.sl.content || strategyParams.combined_sl.content" data-bs-target="#collapseSL" type="button"
            [ngClass]="slTgtClass(strategyParams, 'sl')" (click)="onSLTgtPanelClick(strategyParams, 'sl')"
            aria-expanded="false" aria-controls="collapseSL">SL</a>
            <span class="input-group-text bg-transparent border border-start-0"
            [attr.data-bs-toggle]="strategyParams.sl.content || strategyParams.combined_sl.content" data-bs-target="#collapseSL"
            (click)="onSLTgtPanelClick(strategyParams, 'sl')">
                <i class="bi bi-chevron-down" [ngClass]="slTgtClass(strategyParams, 'sl')"></i>
            </span>
        </div>
    </div>
    <div class="collapse row mt-2" id="collapseSL">
        <div class="col">
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.sl.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'sl')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">Leg</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'sl')">
                        {{ strategyParams.sl.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'sl')"
                            (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'sl')">Points</a></li>
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'sl')"
                            (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'sl')">Percent</a></li>
                    </ul>
                </div>
                <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.sl.value"
                step="0.1" min="1" aria-label="number input for SL value"
                [ngClass]="slTgtErrValueClass(strategyParams, 'sl')">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.combined_sl.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'combined_sl')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">Strategy</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'combined_sl')">
                        {{ strategyParams.combined_sl.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'combined_sl')"
                            (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'combined_sl')">Points</a></li>
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'combined_sl')"
                            (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'combined_sl')">Percent</a></li>
                    </ul>
                </div>
                <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.combined_sl.value"
                step="0.1" min="1" aria-label="number input for SL value"
                [ngClass]="slTgtErrValueClass(strategyParams, 'combined_sl')">
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="input-group mb-3">
            <div class="input-group-text bg-transparent">
                <input class="form-check-input mt-0 shadow-none" type="checkbox"
                [checked]="strategyParams.tsl.state == 'enabled'" [disabled]="strategyParams.sl.state == 'disabled'"
                (change)="onSLTgtCheckChange(strategyParams, $event, 'tsl')"
                aria-label="Checkbox for following text input" >
            </div>
            <a class="btn bg-transparent border border-start-0 flex-fill"
            [attr.data-bs-toggle]="strategyParams.tsl.content" data-bs-target="#collapseTSL" type="button"
            [ngClass]="slTgtClass(strategyParams, 'tsl')" (click)="onSLTgtPanelClick(strategyParams, 'tsl')"
            aria-expanded="false" aria-controls="collapseTSL">TSL</a>
            <span class="input-group-text bg-transparent border border-start-0"
            [attr.data-bs-toggle]="strategyParams.tsl.content" data-bs-target="#collapseTSL"
            (click)="onSLTgtPanelClick(strategyParams, 'tsl')">
                <i class="bi bi-chevron-down" [ngClass]="slTgtClass(strategyParams, 'tsl')"></i>
            </span>
        </div>
    </div>
    <div class="collapse row mt-2" id="collapseTSL">
        <div class="col-md-9">
            <div class="input-group">
                <button class="btn btn-outline-secondary dropdown-toggle form-control shadow-none"
                type="button" data-bs-toggle="dropdown" 
                aria-expanded="false"  [ngClass]="slTgtErrTypeClass(strategyParams, 'tsl')">
                    {{ strategyParams.tsl.type_text }}
                </button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'tsl')"
                        (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'tsl')">Points</a></li>
                    <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'tsl')"
                        (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'tsl')">Percent</a></li>
                </ul>
                <input type="number" min="1" step="1" max="100" class="form-control txt-al-center shadow-none"
                [(ngModel)]="strategyParams.tsl.sl" aria-label="Number input for TSL"
                [disabled]="strategyParams.tsl.state == 'disabled'" [ngClass]="slTgtErrValueClass(strategyParams, 'tslv')">
                <input type="number" min="1" step="1" max="100" class="form-control txt-al-center shadow-none"
                [(ngModel)]="strategyParams.tsl.range" aria-label="Number input for TSL"
                [disabled]="strategyParams.tsl.state == 'disabled'" [ngClass]="slTgtErrValueClass(strategyParams, 'tslr')">
            </div>
            <div class="invalid-feedback" [ngClass]="tslValueClass(strategyParams)">
                SL Value should be lesser than trail range value.
            </div>
        </div>
        <div class="col-md-3">
            <input class="form-check-input mt-0 shadow-none" type="checkbox" 
            [checked]="strategyParams.tsl.ctc == 1"
            (change)="onTSLCTCCheckChange(strategyParams, $event)"
            aria-label="Checkbox for following text input" >
            <span>CTC</span>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-auto pe-0" *ngFor="let d of days">
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <div class="input-group-text d-block p-1 border-0 bg-white">
                        <input type="checkbox" aria-label="Checkbox for days" [(ngModel)]="strategyParams.days[d]"
                        >
                    </div>
                </div>
                <span class="input-group-text flex-nowrap p-1 border-0 bg-white">{{ d }}</span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label class="form-label">&nbsp;</label>
        </div>
    </div>
</div>
